/**
 * Formats an entity type and ID into a standardized URN (Uniform Resource Name).
 * The URN follows the format: `enr:<entity-type>:<id>`.
 *
 * @param entityType The type of the entity (e.g., 'project', 'site', 'location', 'deployment').
 * @param id The unique identifier (UUID) of the specific entity.
 * @returns The formatted entity URN string.
 */
export const getEntityUrnById = (entityType: 'project' | 'site' | 'location' | 'deployment', id: string): string => {
  return `enr:${entityType}:${id}`;
};
